// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__YwKu2","content":"Consent_content__a0LYn","footer":"Consent_footer__XqK--"};